module.exports = {
"Exchange": require('./Exchange.js').default,
"OraclePrice": require('./OraclePrice.js').default,
"Experts": require('./Experts.js').default,
"IndexFactory": require('./IndexFactory.js').default,
"Faucet": require('./Faucet.js').default,
"OracleTotSupply": require('./OracleTotSupply.js').default,
"Lstorage": require('./Lstorage.js').default,
"UniswapV2Factory": require('./UniswapV2Factory.js').default,
"ExpertsRewards": require('./ExpertsRewards.js').default,
"Index2SwapEthMarket": require('./Index2SwapEthMarket.js').default,
"IndexFactorySvet": require('./IndexFactorySvet.js').default,
"Migrations": require('./Migrations.js').default,
"IndexTokens": require('./IndexTokens.js').default,
"WETH": require('./WETH.js').default,
"IUniswapV2Callee": require('./IUniswapV2Callee.js').default,
"UniswapV2ERC20": require('./UniswapV2ERC20.js').default,
"Index2SwapEth": require('./Index2SwapEth.js').default,
"IUniswapV2Pair": require('./IUniswapV2Pair.js').default,
"IUniswapV2Factory": require('./IUniswapV2Factory.js').default,
"SVTtst": require('./SVTtst.js').default,
"IUniswapV2ERC20": require('./IUniswapV2ERC20.js').default,
"IndexToken": require('./IndexToken.js').default,
"iExperts": require('./iExperts.js').default,
"Math": require('./Math.js').default,
"IUniswapV2Router02": require('./IUniswapV2Router02.js').default,
"Context": require('./Context.js').default,
"iLstorage": require('./iLstorage.js').default,
"iOraclePrice": require('./iOraclePrice.js').default,
"IWETH": require('./IWETH.js').default,
"iOracleCircAmount": require('./iOracleCircAmount.js').default,
"UQ112x112": require('./UQ112x112.js').default,
"SafeMath": require('./SafeMath.js').default,
"TransferHelper": require('./TransferHelper.js').default,
"FixedPoint": require('./FixedPoint.js').default,
"Roles": require('./Roles.js').default,
"MinterRole": require('./MinterRole.js').default,
"ERC20Detailed": require('./ERC20Detailed.js').default,
"ERC20Mintable": require('./ERC20Mintable.js').default,
"IERC20": require('./IERC20.js').default,
"ExpertPrices": require('./ExpertPrices.js').default,
"IndexTokenSvet": require('./IndexTokenSvet.js').default,
"IndexStorage": require('./IndexStorage.js').default,
"TokTst": require('./TokTst.js').default,
"ERC20": require('./ERC20.js').default,
"IERC20Uniswap": require('./IERC20Uniswap.js').default,
"OracleCircAmount": require('./OracleCircAmount.js').default,
"SimpleStorage": require('./SimpleStorage.js').default,
"iOracleTotSupply": require('./iOracleTotSupply.js').default,
"SafeMathUniswap": require('./SafeMathUniswap.js').default,
"iIndex2Swap": require('./iIndex2Swap.js').default,
"iIndexStorage": require('./iIndexStorage.js').default,
"IUniswapV2Router01": require('./IUniswapV2Router01.js').default,
"UniswapV2Pair": require('./UniswapV2Pair.js').default,
"ERC20Capped": require('./ERC20Capped.js').default,
"Index2Swap": require('./Index2Swap.js').default,
"iIndexToken": require('./iIndexToken.js').default,
"UniswapV2OracleLibrary": require('./UniswapV2OracleLibrary.js').default,
};